import { API } from 'components/CommonFunc/amplifyApiCompat';
import {gppApiConsts} from "./GppApiConsts";
import {Indel} from "./IndelForm";
import {Plasmid} from "./PlasmidForm";
import {WesternBlot} from "./WesternBlotForm";
import {InHouseCellLine, TABLE_NAME as IN_HOUSE_CELL_LINE_TABLE_NAME} from "./InHouseCellLineForm";

export class GppTableDataApi {
    static searchTable(keywords: string, columns: string, table: string, comparator: string): Promise<Indel[] | Plasmid[] | WesternBlot[] | InHouseCellLine[]> {
        if (columns === "" && table === IN_HOUSE_CELL_LINE_TABLE_NAME) {
            columns = "any"
        }

        return API.get(
            gppApiConsts.API_NAME,
            gppApiConsts.tableData.path.TABLE_DATA,
            {
                queryParams: {
                    table: table,
                    database: gppApiConsts.DATABASE_NAME,
                    keywords: keywords,
                    columns: columns.replace(/\s/g,''),
                    comparator: comparator,
                },
            }).then(response => response["data"])
    }
}